<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">杠杆交易</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>交易记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create @refresh="getProjectList"></create>
        <el-select
          v-model="pair"
          placeholder="请选择"
          @change="search()"
          clearable=""
        >
          <el-option
            v-for="item in pairList"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </div>
      <div class="sum" v-show="pair">
        <div></div>
        <div class="one">合计：</div>
        <div class="one">{{ pair }}</div>
        <div>
          <div>{{ CoinSum.sumCoinAmount }} {{ CoinSum.coinType }}</div>
          <div>{{ CoinSum.sumSetCoinAmount }} {{ CoinSum.setCoinType }}</div>
        </div>
        <div>
          <div>{{ CoinSum.sumCoinFroze }} {{ CoinSum.coinType }}</div>
          <div>{{ CoinSum.sumSetCoinFroze }} {{ CoinSum.setCoinType }}</div>
        </div>
        <div>
          <div>{{ CoinSum.sumCoinBorrow }} {{ CoinSum.coinType }}</div>
          <div>{{ CoinSum.sumSetCoinBorrow }} {{ CoinSum.setCoinType }}</div>
        </div>
        <div>
          <div>{{ CoinSum.sumCoinInterest }} {{ CoinSum.coinType }}</div>
          <div>
            {{ CoinSum.sumSetCoinInterest }}
            {{ CoinSum.setCoinType }}
          </div>
        </div>
      </div>
      <list @refresh="getProjectList"></list>
    </el-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Create from './components/create';
import List from './components/list';

export default {
  name: 'leverRecord',
  data() {
    return {
      updated: '',
      pair: ''
    };
  },
  components: {
    List,
    Create
  },
  computed: {
    ...mapState('leverRecord', ['pagination', 'pairList', 'CoinSum'])
  },
  methods: {
    ...mapActions('leverRecord', [
      'getList',
      'getSum',
      'listAllCoin',
      'freshData',
      'getIdamount'
    ]),
    getProjectList(data = {}) {
      this.getList({
        ...data
      });
    },
    update() {
      this.freshData({ target: this.updated }).then(() => {
        this.updated = '';
      });
    },
    search() {
      this.getProjectList({ pair: this.pair });
      this.getSum({ pair: this.pair });
    }
  },
  created() {
    this.getProjectList();
    this.listAllCoin();
  }
};
</script>
<style lang="less" scoped>
.change {
  ::v-deep .el-button {
    margin-left: 20px;
  }
}
.sum {
  display: flex;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
  padding: 10px 0;
  div {
    width: 14.25%;
    padding-left: 5px;
    div {
      width: 100%;
    }
  }
  .one {
    line-height: 33px;
  }
}
</style>
